const roundBill = (bill) => {
  return +( Math.floor(bill * 10 ) / 10 ).toFixed(1)
}

export default roundBill